import { Link, useLocation } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function NotFound() {
  const location = useLocation();

  usePageMeta({
    title: "页面不存在 - 韩国伦理电影在线观看",
    description: "你访问的页面不存在或已被移动，请返回首页或从片库重新查找影片。",
  });

  return (
    <Layout>
      <div className="px-4 md:px-8 lg:px-12 py-20 md:py-28">
        <div className="max-w-shell mx-auto">
          <div className="relative rounded-lg border border-background-200/70 bg-background-100/40 overflow-hidden">
            <span className="absolute -right-6 -top-10 font-label text-[180px] md:text-[260px] leading-none text-background-200/40 select-none pointer-events-none">
              404
            </span>
            <div className="relative px-6 md:px-12 py-16 md:py-24 max-w-xl">
              <p className="font-label text-xs tracking-[0.32em] text-primary-500 mb-3">PAGE NOT FOUND</p>
              <h1 className="font-heading text-2xl md:text-4xl text-foreground-950 font-bold">
                这个页面走丢了
              </h1>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                你访问的地址 <span className="text-foreground-900 break-all">{location.pathname}</span>{" "}
                不存在，可能是链接输入有误，或者页面已经调整。
              </p>
              <div className="mt-7 flex flex-wrap gap-3">
                <Link
                  to="/"
                  className="h-10 px-5 rounded-md bg-primary-500 text-background-50 text-sm font-medium flex items-center gap-2 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-home-4-line" aria-hidden="true"></i>
                  返回首页
                </Link>
                <Link
                  to="/category/all"
                  className="h-10 px-5 rounded-md border border-background-300 text-foreground-800 text-sm flex items-center gap-2 hover:border-primary-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                >
                  浏览全部片库
                  <i className="ri-arrow-right-line" aria-hidden="true"></i>
                </Link>
                <Link
                  to="/search"
                  className="h-10 px-5 rounded-md border border-background-300 text-foreground-800 text-sm flex items-center gap-2 hover:border-primary-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                >
                  搜索影片
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}